module.exports = __webpack_public_path__ + "img/서비스AgeTech_old.d0c2c316.png";